import { Typography, Box, Chip } from "@mui/material";
export default function SectionTitle({
  icon,
  title,
  subtitle,
  count,
  color = "#4FC3F7",
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 5,
        px: 2,
        py: 2,
        background: "rgba(255, 255, 255, 0.03)",
        backdropFilter: "blur(20px)",
        borderRadius: 4,
        border: "1px solid rgba(255, 255, 255, 0.1)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Box
          sx={{
            width: 50,
            height: 50,
            borderRadius: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: `rgba(255, 255, 255, 0.05)`,
            backdropFilter: "blur(10px)",
            border: `1px solid rgba(255, 255, 255, 0.1)`,
            color: color,
            fontSize: 24,
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography variant="h6" fontWeight={600} sx={{ color: "#fff" }}>
            {title}
          </Typography>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.6)" }}>
            {subtitle}
          </Typography>
        </Box>
      </Box>
      <Chip
        label={`${count} طرح فعال`}
        sx={{
          bgcolor: "rgba(255, 255, 255, 0.05)",
          color: "#fff",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          fontWeight: 600,
        }}
      />
    </Box>
  );
}
